import { jsx as _jsx } from "react/jsx-runtime";
import MuiAlert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import React from "react";
const Alert = React.forwardRef(function Alert(props, ref) {
    return _jsx(MuiAlert, { elevation: 6, ref: ref, variant: "filled", ...props });
});
const SuccessSnackbar = ({ open, onClose = () => { }, message, }) => {
    return (_jsx(Snackbar, { open: open, autoHideDuration: 4000, onClose: onClose, children: _jsx(Alert, { onClose: onClose, severity: "success", sx: { width: "100%" }, children: message }) }));
};
export default SuccessSnackbar;
